import React from 'react'
import PropTypes from 'prop-types'
import useLocalStorage from './use-local-storage-auth'
import useBackend from './use-backend'

const AuthContext = React.createContext()

// Provider component that wraps your app and makes auth object ...
// ... available to any child component that calls useAuth().
export function ProvideAuth({ children, type, authUrl }) {
  let auth = null
  const localAuth = useLocalStorage()
  const backendAuth = useBackend(authUrl)
  switch (type) {
    case 'local': auth = localAuth; break
    case 'backend': auth = backendAuth; break
    default: auth = backendAuth
  }
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
}

ProvideAuth.defaultProps = {
  authUrl: '/auth',
}

ProvideAuth.propTypes = {
  children: PropTypes.node.isRequired,
  authUrl: PropTypes.string,
  type: PropTypes.oneOf(['local', 'backend']).isRequired,
}

// Hook for child components to get the auth object ...
// ... and re-render when it changes.
export const useAuth = () => React.useContext(AuthContext)
